module.exports = __webpack_public_path__ + "static/img/liansuo.5d579c3d.png";